<template>
  <div class="list" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
    <template v-for="item in list">
      <OrderItem :data="item" :key="item.tradeInfo.id" @update="refersh" v-if="item"></OrderItem>
    </template>
    <loading :loading="loading" :loaded="loaded"></loading>
  </div>
</template>

<script>
import OrderItem from './OrderItem'
import Loading from '@/components/Loading'
import { getOrderList } from '@/api/order'
export default {
  name: 'InfiniteScrollOrderList',
  props: {
    visible: { type: Boolean, default: false },
    status: { type: String, default: '' }
  },
  data() {
    return {
      loading: false,
      loaded: false,
      page: {
        index: '',
        size: 10
      },
      list: []
    }
  },
  components: { OrderItem, Loading },
  watch: {
    visible() {
      this.visible && this.refersh()
    }
  },
  methods: {
    getList() {
      this.loading = true
      return getOrderList({
        tradeState: this.status,
        page: this.page
      }).then(response => {
        var data = response.data
        if (data.list && data.list.length) {
          this.list = this.list.concat(data.list)
          this.loading = false
        } else {
          this.loaded = true
        }
        Object.assign(this.page, data.next)
      })
    },
    loadMore() {
      this.visible && this.getList()
    },
    refersh() {
      this.page.index = ''
      this.list.splice(0)
      this.getList()
    }
  }
}
</script>
